import React from "react";
import { isEmpty } from "lodash";
import { FormControlLabel, Checkbox } from "@material-ui/core";
import { Box, Typography, Grid, Button } from "@material-ui/core";
import SentimentDissatisfiedIcon from "@material-ui/icons/SentimentDissatisfied";
// direct import
import "../style.scss";

const RenewalOptions = ({
  customChecked,
  setCustomChecked,
  values,
  currency,
  membershipPriceType,
}) => {
  const isDynamic = membershipPriceType === "dynamic";
  const getAmounts = values
    ?.filter(
      (amount) =>
        (amount?.amount !== 0 && amount?.amount !== "") ||
        (amount?.addAmount !== 0 && amount?.addAmount !== "")
    )
    ?.map((el) => ({
      amount: el?.amount || el?.addAmount,
      amountType: el?.amountType,
      isStatic: el?.static,
    }));

  const isOpenAmount = values?.find((el) => el?.openAmount === true);
  console.log("getAmounts", getAmounts);
  return (
    <Box className="summary-renewal__card">
      <Typography className="summary-renewal__title">
        Renewal Options
      </Typography>
      {!isEmpty(getAmounts) && (
        <Typography className="summary-renewal__desc">
          Our costs increase every year due to inflation, please consider
          increasing your dues.
        </Typography>
      )}

      <Grid container spacing={2} className="summary-renewal__options">
        {getAmounts?.map((el, i) => (
          <Grid item xs={4} key={i}>
            <Button
              fullWidth
              variant="outlined"
              className={`summary-renewal__option-button desc`}
              style={{ fontSize: 14, fontWeight: 500 }}
            >
              {isDynamic && !el.isStatic ? "+" : ""}
              {el.amountType === "$" ? currency : ""}
              {Number(el.amount).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
              {el.amountType === "$" ? "" : el.amountType}
            </Button>
          </Grid>
        ))}
      </Grid>
      {isEmpty(getAmounts) && (
        <Box
          sx={{
            flexDirection: "column",
            height: 100,
            alignItems: "center",
            display: "flex",
            justifyContent: "center",
            width: "100%",
          }}
        >
          <SentimentDissatisfiedIcon fontSize="large" />
          <Typography variant="h6">No data available.</Typography>
        </Box>
      )}
      {/* {!isEmpty(getAmounts) && (
        <FormControlLabel
          control={
            <Checkbox
              color="primary"
              checked={customChecked}
              onChange={(e) => setCustomChecked(e.target.checked)}
              className="summary-renewal__checkbox"
            />
          }
          label={
            <Typography className="summary-renewal__checkbox-label heading">
              I'd like to increase my dues pledge by more or less than the
              suggested amount.
            </Typography>
          }
          className="summary-renewal__checkbox-container"
        />
      )} */}
      {isOpenAmount && (
        <Box className="summary-renewal__checkbox-container">
          <FormControlLabel
            control={<Checkbox color="primary" checked disabled />}
            label={
              <Typography className="summary-renewal__checkbox-label">
                Other Amount
              </Typography>
            }
          />
        </Box>
      )}
    </Box>
  );
};

export default RenewalOptions;
